import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_REFERRAL_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getReferralReferenceData = createAsyncThunk(
    'stop/getReferralReferenceData',
    async (params) => {
      const config = {
        headers: {
          Authorization: params,
          Region: STOP_REGION
        },
      };
      const response = await axios
        .get(EPISODE_REFERRAL_REFERENCE_DATA_URL, config)
        .then((response) => {
          return response;
        })
        .catch((e) => {
          console.log(e);
          return e;
        });
      const data = await response.data.data;
      return data === undefined ? null : data;
    }
  );

  const resetReferralReferenceSlice = createSlice({
    name: 'stop/referralReference',
    initialState: null,
    reducers: {
      resetReferralReference: () => null,
    },
    extraReducers: {
      [getReferralReferenceData.fulfilled]: (state, action) => action.payload,
    },
  });
  
  export const { resetReferralReference } = resetReferralReferenceSlice.actions;
  
  export default resetReferralReferenceSlice.reducer;